import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    isProposalDetailsPartiallyFilled: false
}

export const applyBriefSlice = createSlice({
    name: 'applyBrief',
    initialState,
    reducers: {
        setIsProposalDetailsPartiallyFilled: (state, action) => {
            state.isProposalDetailsPartiallyFilled = action.payload.isProposalDetailsPartiallyFilled;
        }
    }
})

export const { setIsProposalDetailsPartiallyFilled } = applyBriefSlice.actions

export default applyBriefSlice.reducer